export enum WhapiChannelScope {
    DRIVER = 'DRIVER',
    ORGANISATION = 'ORGANISATION'
}